<template>
    <div class="table-responsive">
        <table class="table table-bordered table-sm table-hover mb-0">
            <thead class="thead-light">
                <tr>
                    <th class="text-center">{{ "시간" }}</th>
                    <th class="text-center">{{ `보정후 (${unit})` }}</th>
                    <th class="text-center">{{ `보정전 (${unit})` }}</th>
                    <th class="text-center">{{ `원시값 (${unit})` }}</th>
                    <th class="text-center">{{ `이전값 (${unit})` }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, idx) in formattedData" :key="idx">
                    <td class="text-center">{{ row.time ?? "-" }}</td>
                    <td class="text-right">{{ row.ptVal !== null ? row.ptVal : "-" }}</td>
                    <td class="text-right">{{ row.ptValRaw !== null ? row.ptValRaw : "-" }}</td>
                    <td class="text-right">{{ row.ptOrg !== null ? row.ptOrg : "-" }}</td>
                    <td class="text-right">{{ row.ptPre !== null ? row.ptPre : "-" }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment";
import excelHelper from "@src/libs/excelHelper.js";

export default {
    props: {
        data: { type: Array, default: () => [] },
        unit: { type: String, default: "" },
        downloadFlag: { type: Boolean, default: false },
    },
    components: {},
    data() {
        return {};
    },
    computed: {
        formattedData() {
            return this.data.map((item) => ({
                time: moment(item.regDt.toString(), "YYYYMMDDHHmmss").format("HH:mm:ss"),
                ptVal: item.ptVal !== null ? item.ptVal : "-",
                ptValRaw: item.ptValRaw !== null ? item.ptValRaw : "-",
                ptOrg: item.ptOrg !== null ? item.ptOrg : "-",
                ptPre: item.ptPre !== null ? item.ptPre : "-",
            }));
        },
    },
    watch: {
        downloadFlag(val) {
            if (val) {
                this.exportToExcel();
            }
        },
    },
    created() {},
    mounted() {},
    methods: {
        async exportToExcel() {
            try {
                // 헤더 정의
                const headers = [
                    "시간",
                    `보정후 (${this.unit})`,
                    `보정전 (${this.unit})`,
                    `원시값 (${this.unit})`,
                    `이전값 (${this.unit})`,
                ];

                // 데이터 변환 (excelHelper 형식에 맞게)
                const excelData = this.formattedData.map((item) => ({
                    시간: item.time || "-",
                    [`보정후 (${this.unit})`]: item.ptVal !== null ? item.ptVal : "-",
                    [`보정전 (${this.unit})`]: item.ptValRaw !== null ? item.ptValRaw : "-",
                    [`원시값 (${this.unit})`]: item.ptOrg !== null ? item.ptOrg : "-",
                    [`이전값 (${this.unit})`]: item.ptPre !== null ? item.ptPre : "-",
                }));

                // 파일명 생성 (현재 날짜 포함)
                const currentDate = new Date().toISOString().slice(0, 10);
                const fileName = `보정_데이터_${currentDate}.xlsx`;

                // excelHelper를 사용하여 워크북 생성 및 다운로드
                await excelHelper.createAndDownloadWorkbook(excelData, headers, fileName, {
                    sheetName: "보정_데이터",
                    creator: "THEKIE",
                    lastModifiedBy: "THEKIE",
                    columnWidths: {
                        시간: 12,
                        [`보정후 (${this.unit})`]: 15,
                        [`보정전 (${this.unit})`]: 15,
                        [`원시값 (${this.unit})`]: 15,
                        [`이전값 (${this.unit})`]: 15,
                    },
                    cellTypes: {
                        시간: "string",
                        [`보정후 (${this.unit})`]: "number",
                        [`보정전 (${this.unit})`]: "number",
                        [`원시값 (${this.unit})`]: "number",
                        [`이전값 (${this.unit})`]: "number",
                    },
                });

                this.$emit("update:downloadFlag", false);
            } catch (error) {
                console.error("엑셀 다운로드 중 오류 발생:", error);
                this.$emit("download-error", error.message);
            }
        },
    },
};
</script>

<style scoped>
/* .table-responsive {
    height: 40vh;
    overflow-y: auto;
} */
.table-responsive {
    height: 70vh;
    overflow-y: auto;
    position: relative;
}
table {
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
}

thead {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
}
.table thead th {
    font-size: 13px;
    font-weight: 600;
}
.table tbody td {
    font-size: 13px;
}
</style>
